import values from '../../../res/values';
import color from '../../../res/color';

export default {
    main: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        // overflow: 'hidden',
        color: color.whiteFontColor,
        fontSize: values.fontMax,
        userSelect: "none",
    },
}